import React, {Component} from 'react';
import AppStore from "./flux/AppStore";
import PageEvents from "./pages/PageEvents";
import PageBrands from "./pages/PageBrands";
import PageCocktails from "./pages/PageCocktails";
import PageCocktailsBeefeaterIsHot from "./pages/PageCocktailsBeefeaterIsHot";
import PageNotFound from "./pages/PageNotFound";
import PageShoppingList from "./pages/PageShoppingList";
import PageShoppingListBeefeaterIsHot from "./pages/PageShoppingListBeefeaterIsHot";
import LocalStorage from "./util/LocalStorage";
import AppActions from "./flux/AppActions";
import Toast from "./toast";
import AjaxLoader from "./components/AjaxLoader";

const $ = window.jQuery;
const toast = new Toast();
const locale = (typeof (window.AppWizardLocale) !== 'undefined' ? window.AppWizardLocale : false);
if (!locale) {
    throw new Error('Error: Locale not loaded');
}

const Components = {
    events: PageEvents,
    brands: PageBrands,
    cocktails: PageCocktails,
    cocktailsBeefeaterIsHot: PageCocktailsBeefeaterIsHot,
    shopping_list: PageShoppingList,
    shoppingListBeefeaterIsHot: PageShoppingListBeefeaterIsHot,
    none: PageNotFound,
};

class App extends Component {
    constructor(props) {
        super(props);

        this.getStoreData = this.getStoreData.bind(this);

        this.ls = new LocalStorage();

        this.state = Object.assign(
            AppStore.getData(),
            {
                loading: true,
                page: props.startPage,
                campaignInfo: props.campaignInfo
            }
        );

        AppActions.updateStore({
            ls: this.ls
        });
    }

    componentDidMount() {
        AppStore.on("change", this.getStoreData);

        let page = this.state.page;
        let {ajaxurl, nonce_name, nonce_value} = locale;
        let ajaxConfig = {
            url: ajaxurl,
            method: "POST",
            timeout: 29000,
            cache: false,
            async: true,
            data: {
                action: "bth_ajax",
                request: "get_brands",
                campaign: this.props.campaign,
                event: this.props.event,
                [nonce_name]: nonce_value
            }
        };

        $.ajax(ajaxConfig)
            .done(function (r) {
                if (r) {
                    if (r.success) {
                        if (r.data) {
                            if (r.data.items.length === 1) {
                                AppActions.updateStore({
                                    brands: r.data.items,
                                    brand: r.data.items[0],
                                    page: 'cocktails',
                                    loading: false
                                });
                            } else {
                                AppActions.updateStore({
                                    brands: r.data.items,
                                    event: r.data.event,
                                    page: page,
                                    loading: false
                                });
                            }
                        } else {
                            toast.show(locale.texts.empty_response, Toast.TYPE_ERROR);
                        }
                    } else {
                        if (r.data) {
                            toast.show(r.data, Toast.TYPE_ERROR);
                        } else {
                            toast.show(locale.texts.empty_response, Toast.TYPE_ERROR);
                        }
                    }
                } else {
                    toast.show(locale.texts.no_response, Toast.TYPE_ERROR);
                }
            })
            .fail(function (x, s, e) {
                toast.show(e, Toast.TYPE_ERROR);
            })
            .always(function () {
                // self.setState( {
                //     loading: false
                // } );
            });
    }

    componentWillUnmount() {
        AppStore.removeListener("change", this.getStoreData);
    }

    getStoreData() {
        this.setState(AppStore.getData());
    }

    render() {
        let Page = Components[this.state.page];

        return (
            <React.Fragment>
                {this.state.loading ? <AjaxLoader/> :
                    <Page app={this} locale={locale}/>}
            </React.Fragment>
        );
    }
}

export default App;
